/* eslint-disable prettier/prettier */
import Component from '../abstracts/Component';
import { doAjax } from '../utils/ajaxUtil';
import TrackingComponent from '../components/TrackingComponent';
import { MODAL_DIALOG_EVENTS } from './ModalDialogComponent';
import ListingProductCard from './ListingProductCard';
import _ from 'lodash';
import {Tooltip} from 'bootstrap';
import OnDemandLiveRegion from "../utils/OnDemandLiveRegion";


export default class WishlistComponent extends Component {

  get SELECTORS() {
    return {
      wishBtn: '.js-wishlist-cta',
      wishBtnPaged: '.js-wishlist-cta:not(.component-loaded)',
      qtyWishlist: '.wishlistCount',

      wishlistNotifyMe: '.wishlist-notify-me',
      wishlistAddToCart: '.wishlist-add-to-cart',
      wishlistRemove: '.wishlist-remove',

      addToCartButtonList: '[data-add-to-cart]',

      productCards: '.c-product-card',
      wishlistNotification: '.p-wishlist__notification',
      wishtlistButtonText: '.text-wishlist',
    };
  }

  get CLASSES() {
    return {
      deleteBtnClass: 'wishlist-remove',
      addBtnClass: 'js-add-to-wish',
      addedBtnClass: 'js-added-wish',
      removeBtnClass: 'js-remove-from-wish',
      iconWishlistEmpty: "icon-wishlist-empty",
      iconWishlistFull: "icon-wishlist-full",
      error: 'error',

      sizeProductOption: 'size-product-option',
      show: 'show'
    };
  }

  constructor(el) {
    super(el);
    // all wishlist button of
    this.wishBtn = document.querySelectorAll(this.SELECTORS.wishBtn);
    this.TrackingComponent = new TrackingComponent();
    this.qtyWishlist = $(this.SELECTORS.qtyWishlist);

    this.wishlistNotifyMeList = document.querySelectorAll(this.SELECTORS.wishlistNotifyMe);
    this.wishlistAddToCartList = document.querySelectorAll(this.SELECTORS.wishlistAddToCart);
    this.wishlistRemoveList = document.querySelectorAll(this.SELECTORS.wishlistRemove);

    this.addToCartButtonList = document.querySelectorAll(this.SELECTORS.addToCartButtonList);

    this.productCards = this.$component.querySelectorAll(this.SELECTORS.productCards);
    this.wishlistNotification = this.$component.querySelector(this.SELECTORS.wishlistNotification);
    this.liveRegion = new OnDemandLiveRegion({
      level: "assertive",
      delay: 1000,
    });
    this.a11yMessages = {
      wishlist: {
        added: this.$component.dataset.labelAdded || "",
        removed: this.$component.dataset.labelRemoved || "",
        error: this.$component.dataset.labelAddError || "",
      },
      cart: {
        added: this.$component.dataset.labelCartAdded || "",
        error: this.$component.dataset.labelCartAddError || "",
      },
    };
  }

  // listen to click
  listenBtnWish(btns) {
    // global
    let ctx = this;
    // if not passed
    if ( typeof btns == 'undefined') btns = this.wishBtn;
    //
    if (btns != null) {
      btns.forEach(btn => {
        btn.addEventListener("click", (elem) => {
          // no default action
          elem.stopPropagation();
          elem.preventDefault();
          // in base of button class
          if (btn.classList.contains(ctx.CLASSES.addBtnClass)) {
            // adding
            let url = btn.getAttribute('data-wish-add-url');
            const debouncedFunction = _.debounce(() => ctx.addToWishlist(btn, url), 300);
            debouncedFunction();
          } else {
            // removing
            let url = btn.getAttribute('data-wish-remove-url');
            const debouncedFunction = _.debounce(() => ctx.removeToWishlist(btn, url), 300);
            debouncedFunction();
          }
        });
      });
    }
  }

  //
  addToWishlist(elem,url) {
    // vars
    let ctx = this;
    let code = elem.dataset.code;
    // ajax
    doAjax({
      url:  url,
      data: {
        code: code
      },
      dataType: "html",
      success: function (resp) {
        ctx.log('added to wishlist',code);
        // n of items on wishlist
        let qty = resp;
        // event
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addedtowish, {elem: elem, qty: qty});
        ctx.TrackingComponent.trackAction('wishlistAdd', elem.dataset, elem);
        elem.dataset.labelRemove && (elem.querySelector(ctx.SELECTORS.wishtlistButtonText).textContent = elem.dataset.labelRemove);
        ctx.liveRegion.sayMessage(ctx.a11yMessages.wishlist.added);
      },
      error: function (xhr) {
        console.log('error in add to wishlist');
        ctx.liveRegion.sayMessage(ctx.a11yMessages.wishlist.error);
      }
    });
  }

  redirectToWishlist(params) {
    // redirect to same url with query param or not
    window.location.href = `${window.location.pathname}${params ? `?wishlistNotification=${params}` : ''}`;
  }

  //
  removeToWishlist(elem,url, isWishlist = false) {
    // vars
    let ctx = this;
    let code = elem.dataset.code;
    const categoryCode = elem.dataset.categoryCode;

    // query params
    let urlSearchParams = new URLSearchParams(window.location.search);
    const qParam = urlSearchParams.get('q');
    // ajax
    doAjax({
      url:  url,
      data:{
        productCode: code,
        categoryCode: (categoryCode && categoryCode !== '') ? categoryCode : null,
        q: qParam ? qParam : null
      },
      dataType: "json",
      type: 'POST',
      success: function (resp) {
        // n of items on wishlist
        let qty = resp.count;
        const label = resp.countLabel;
        // if we are in a category and count is 0, redirect to wishlist with params to notification
        if (document.body.classList.contains('t-wishlist')) {
          if ((qty === 0) && (categoryCode && categoryCode !== '') && resp.totalCount !== 0) {
            // this condition could be also on resp.categoryCount
            if (qParam && qParam !== '') {
              ctx.redirectToWishlist('emptyFilterError');
            } else {
              ctx.redirectToWishlist('emptyCategoryError');
            }
          } else if ((qty === 0) && !categoryCode && resp.totalCount !== 0) {
            ctx.redirectToWishlist('emptyFilterError');
          }
          // if we have no more elements, redirect to wishlist without params
          else if (resp.totalCount === 0) ctx.redirectToWishlist()
        }
        // remove element
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.removedfromwish, {elem: elem, qty: qty, label: label, totalCount: resp.totalCount});
        elem.dataset.labelAdd && (elem.querySelector(ctx.SELECTORS.wishtlistButtonText).textContent = elem.dataset.labelAdd);
        ctx.liveRegion.sayMessage(ctx.a11yMessages.wishlist.removed);
      },
      error: function (xhr) {
        console.log(xhr);
      }
    });
  }

  // wishlist check
  wishlistCheckAjax(code) {
    return new Promise( (resolve, reject) => {
      let data = {};
      data[code] = code;
      //
      let contextPath = document.getElementsByTagName('HTML')[0].getAttribute("data-context");
      $.ajax({
        url: contextPath + "/action/ajax/wishlist-check-product",
        data: {
          code: code
        },
        success: function (result) {
          // resolve
          resolve(result);
        }
      });
    });
  }

  updateWishButton(btn,disable) {
    // check
    if (btn == null) return false;
    //
    if ( disable == true) {
      // disable button
      btn.classList.remove(this.CLASSES.addBtnClass, this.CLASSES.iconWishlistEmpty);
      btn.classList.add(this.CLASSES.addedBtnClass, this.CLASSES.removeBtnClass, this.CLASSES.iconWishlistFull);
    } else {
      // enable button
      btn.classList.add(this.CLASSES.addBtnClass, this.CLASSES.iconWishlistEmpty);
      btn.classList.remove(this.CLASSES.addedBtnClass, this.CLASSES.removeBtnClass, this.CLASSES.iconWishlistFull);
    }
  }

  addOpenNotifyMeDialog() {
    if (this.wishlistNotifyMeList) {
      this.wishlistNotifyMeList.forEach((btn, index) => {
        const tooltip = new Tooltip(btn, {placement: 'top', container: btn});
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.$emit(MODAL_DIALOG_EVENTS.OPEN, ({ triggeredBy: `WishlistComponent-NotifyMe-${btn.id}`, id: btn.id }))
        })})
      }
  }

  addOpenAddToCartDialog() {
    if (this.wishlistAddToCartList) {
      this.wishlistAddToCartList.forEach((btn, index) => {
        const tooltip = new Tooltip(btn, {placement: 'top', container: btn});
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.$emit(MODAL_DIALOG_EVENTS.OPEN, ({ triggeredBy: `WishlistComponent-AddToCart-${btn.id}`, id: btn.id }))
        })})
      }
  }

  addRemoveFromWishlistClick() {
    if (this.wishlistRemoveList) {
      let ctx = this;
      this.wishlistRemoveList.forEach(btn => {
        let {
          link
        } = btn.dataset

        if (link) {
          btn.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();

            ctx.removeToWishlist(btn, link, true);
          })
        }
      })
    }
  }

  addAddToCartButtonClick() {
    if (this.addToCartButtonList) {
      this.addToCartButtonList.forEach(btn => {
        btn.addEventListener('click', (e) => {
          let contextPath = document.getElementsByTagName('HTML')[0].getAttribute("data-context")
          doAjax({
            url: btn.getAttribute('data-link'),
            success: (res) => {
              let that = this
              if (res == 650) {
                doAjax({
                  url: `${window.location.origin}${contextPath}/action/ajax/modal-exceeded-cart-qty?wishlist=true&productCode=${btn.dataset.addToCart}`,
                  dataType: "html",
                  success: function (html) {
                    that.$emit(MODAL_DIALOG_EVENTS.OPEN, ({ triggeredBy: `WishlistComponent-responseDialog-success-${btn.dataset.addToCart}`, id: `WishlistComponent-responseDialog-${btn.dataset.addToCart}`  }))
                    console.info("[AddToCart] Exceed product max number on cart.")
                    $(`#response-container-${btn.dataset.addToCart}`).append(`<div class='exceeded-cart-products'>${html}</div>`);
                    that.liveRegion.sayMessage(that.a11yMessages.cart.error);
                  },
                  error: function (xhr) {
                    //elem.disabled = false;
                    console.error("[AddToCart]", xhr, arguments);
                    that.liveRegion.sayMessage(that.a11yMessages.cart.error);
                  }
                });
              } else if (res == 651) {
                doAjax({
                  url: `${window.location.origin}${contextPath}/action/ajax/modal-lowstock-cart-qty?wishlist=true&productCode=${btn.dataset.addToCart}`,
                  dataType: "html",
                  success: function (html) {
                    that.$emit(MODAL_DIALOG_EVENTS.OPEN, ({ triggeredBy: `WishlistComponent-responseDialog-success-${btn.dataset.addToCart}`, id: `WishlistComponent-responseDialog-${btn.dataset.addToCart}`  }))
                    console.info("[AddToCart] Lowstock product number on cart.")
                    $(`#response-container-${btn.dataset.addToCart}`).append(`<div class='exceeded-cart-products'>${html}</div>`);
                    that.liveRegion.sayMessage(that.a11yMessages.cart.error);
                  },
                  error: function (xhr) {
                    console.error("[AddToCart]", xhr, arguments);
                    that.liveRegion.sayMessage(that.a11yMessages.cart.error);
                  }
                });
              } else {
                that.$emit(that.$customEvents.PRODUCT_EVENTS.addedtocart, {
                  button: btn,
                  inWishlistLayer: true
                });
                that.liveRegion.sayMessage(that.a11yMessages.cart.added);
              }
            },
            error: (res) => {
              console.error("[AddToCart]", res, arguments);
              this.$emit(MODAL_DIALOG_EVENTS.OPEN, ({ triggeredBy: `WishlistComponent-responseDialog-error-${btn.dataset.addToCart}`, id: `WishlistComponent-responseDialog-${btn.dataset.addToCart}` }))
              $(`#response-container-${btn.dataset.addToCart}`).append(`<div class='modal-content'>Error in addtocart ${res.responseText}</div>`);
              that.liveRegion.sayMessage(that.a11yMessages.cart.error);
            },
          })
        })
      })
    }
  }

  showNotification() {
    if (this.wishlistNotification !== null) {
      this.wishlistNotification.classList.add(this.CLASSES.show);
      setTimeout(() => {
        this.wishlistNotification.classList.remove(this.CLASSES.show);
      }, 3000)
    }
  }

  bindEvents() {
    let ctx = this;
    let wCounter = $(this.SELECTORS.qtyWishlist);
    let wishlistCountValue = wCounter.text();
    if(parseInt(wishlistCountValue,10) > 0){
      wCounter.addClass("isVisible")
    }
    // event on add to wish
    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtowish, ({event, payload}) => {
      let btn = payload.elem;
      // adding and removing classes
      btn.classList.remove(ctx.CLASSES.addBtnClass, ctx.CLASSES.iconWishlistEmpty);
      btn.classList.add(ctx.CLASSES.addedBtnClass, ctx.CLASSES.removeBtnClass, ctx.CLASSES.iconWishlistFull);
    });

    // event on remove from wish
    this.$on(this.$customEvents.PRODUCT_EVENTS.removedfromwish, ({event, payload}) => {
      // btn
      let btn = payload.elem;
      // if it's the delete button on wishlist page
      if (btn.classList.contains(ctx.CLASSES.deleteBtnClass)) {
        let code = btn.dataset.code;
        let prodCard = ctx.$component.querySelector('[data-card-code="'+code+'"]');
        if (prodCard != null ) prodCard.remove();
      } else {
        // update classes on btn
        // adding and removing classes
        btn.classList.remove(ctx.CLASSES.addedBtnClass, ctx.CLASSES.removeBtnClass, ctx.CLASSES.iconWishlistFull);
        btn.classList.add(ctx.CLASSES.addBtnClass, "icon-wishlist-empty");
      }
      // update filters - TODO
      ctx.$emit(ctx.$customEvents.WISHLIST.updateFilter, {label: payload.label});
    });

    // listen event add to wishlist
    this.$on(this.$customEvents.PRODUCT_EVENTS.addtowish, ({elem, url}) => {
      // execute add to wishlist
      ctx.addToWishlist(elem, url);
    });

    // event on select size - i want to wishlist the product with the size
    this.$on(this.$customEvents.PRODUCT_EVENTS.sizechanged, ({event, payload}) => {
      // search the btn with the base product code
      let btnWish = document.querySelectorAll('[data-wishlist-code="'+payload.box.dataset.productCode+'"]');
      // put in the button the size code
      if (btnWish){
        btnWish.forEach(btn => {
          btn.dataset.code = payload.button;

          // check size on size seleect
          // go promise
          ctx.wishlistCheckAjax(payload.button).then( (result) => {
            // result
            if (result === 'true') {
              // if is in WL i disanble the button
              ctx.updateWishButton(btn,true);
            } else {
              // if not i enable it
              ctx.updateWishButton(btn,false);
            }
          });
        })
        }
    });

    // event simplebar loader
    this.$on(this.$customEvents.SIMPLEBAR_EVENTS.loaded, ({event, payload}) => {
      // let's search the wish buttons
      let btns = payload.elem.querySelectorAll(ctx.SELECTORS.wishBtn);
      if (btns != null) {
        ctx.listenBtnWish(btns);
      }
    });

    // Size not selected event
    this.$on(this.$customEvents.PRODUCT_EVENTS.sizerequired, (e) => {
      // find error box
      let sizeBox = document.querySelector('[data-sizes-code=prod_'+e.payload.getAttribute('data-code')+']');
      if (sizeBox != null) {
        sizeBox.classList.add(ctx.CLASSES.error);
      }
    });

    // listing page when launched the filters i need to rebind all buttons
    this.$on(this.$customEvents.FILTERS_EVENTS.updated, ({event, payload}) => {
      // let's search the wish buttons
      let btns = document.querySelectorAll(ctx.SELECTORS.wishBtn);
      if (btns != null) {
        ctx.listenBtnWish(btns);
      }
    });

    // listing when fired pagination and infinite scroll
    this.$on(this.$customEvents.INFINITE_SCROLL_EVENTS.loaded, ({event, payload}) => {
      // let's search the wish buttons
      let btns = document.querySelectorAll(ctx.SELECTORS.wishBtnPaged);
      if (btns != null) {
        ctx.listenBtnWish(btns);
      }
    });

    $('.sizes-select', '.wishlist-modal-container').on('select2:select', (e) => {
      let option = e.params.data.element
      let isUnavailable = option.classList.contains('unavailable')
      let productCode = option.dataset.productCode
      let dialogProductCode = option.parentElement.parentElement.dataset.productCode;

      if (isUnavailable) {
        let notifyMeList = document.querySelectorAll('.wishlist-notifyme')
        if (notifyMeList) {
          notifyMeList.forEach(el => {

            if (el.id === `wishlist-notifyme-${productCode.slice(0, -1)}`) el.classList.remove('hide')
          })
        }
      } else {
        let contextPath = document.getElementsByTagName('HTML')[0].getAttribute("data-context")
        this.$emit(MODAL_DIALOG_EVENTS.CLOSE, ({ triggeredBy: `WishlistComponent-AddToCart-${dialogProductCode}`, id: dialogProductCode }))

        doAjax({
          url: `${window.location.origin}${contextPath}/action/addToCart?code=${productCode}&qty=1`,
          success: (res) => {
            let that = this
            if (res == 650) {
              doAjax({
                url: `${window.location.origin}${contextPath}/action/ajax/modal-exceeded-cart-qty?wishlist=true&productCode=${productCode.slice(0, -1)}`,
                dataType: "html",
                success: function (html) {
                  that.$emit(MODAL_DIALOG_EVENTS.OPEN, ({ triggeredBy: `WishlistComponent-responseDialog-success-${productCode.slice(0, -1)}`, id: `WishlistComponent-responseDialog-${productCode.slice(0, -1)}`  }))
                  console.info("[AddToCart] Exceed product max number on cart.")
                  $(`#response-container-${productCode.slice(0, -1)}`).append(`<div class='exceeded-cart-products'>${html}</div>`);
                },
                error: function (xhr) {
                  //elem.disabled = false;
                  console.error("[AddToCart]", xhr, arguments);
                }
              });
            } else if (res == 651) {
              doAjax({
                url: `${window.location.origin}${contextPath}/action/ajax/modal-lowstock-cart-qty?wishlist=true&productCode=${productCode.slice(0, -1)}`,
                dataType: "html",
                success: function (html) {
                  that.$emit(MODAL_DIALOG_EVENTS.OPEN, ({ triggeredBy: `WishlistComponent-responseDialog-success-${productCode.slice(0, -1)}`, id: `WishlistComponent-responseDialog-${productCode.slice(0, -1)}`  }))
                  console.info("[AddToCart] Lowstock product number on cart.")
                  $(`#response-container-${productCode.slice(0, -1)}`).append(`<div class='exceeded-cart-products'>${html}</div>`);
                },
                error: function (xhr) {
                  console.error("[AddToCart]", xhr, arguments);
                }
              });
            } else {
              that.$emit(that.$customEvents.PRODUCT_EVENTS.addedtocart, {
                button: option,
                inWishlistLayer: true
              });
              // track event
              ctx.TrackingComponent.actions.addToCart(productCode);
            }

          },
          error: (res) => {
            console.error("[AddToCart]", res, arguments);
            this.$emit(MODAL_DIALOG_EVENTS.OPEN, ({ triggeredBy: `WishlistComponent-responseDialog-error-${productCode.slice(0, -1)}`, id: `WishlistComponent-responseDialog-${productCode.slice(0, -1)}` }))
            $(`#response-container-${productCode.slice(0, -1)}`).append(`<div class='modal-content'>Error in addtocart ${res.responseText}</div>`);
          },
        })

      }
    })

    this.$on(MODAL_DIALOG_EVENTS.CLOSE, ({ payload }) => {

      $('.response-container').each((i, el) => {
        $( el ).empty()}
      )

    })

    this.addOpenNotifyMeDialog()
    this.addOpenAddToCartDialog()
    this.addRemoveFromWishlistClick()
    this.addAddToCartButtonClick()
  }

  render(html = null) {
    this.log('Rendering...');
    this.bindEvents();
    // add btn
    this.listenBtnWish(html ? html : undefined);

    // create an instance of ListingProductCard for each product card
    if (this.productCards && this.productCards.length) {
      this.productCards.forEach(pc => {
        let component = new ListingProductCard(pc);
        component.render();
      })
    }

    const notificationEl = $(this.SELECTORS.wishlistNotification);
    if (notificationEl) {
      setTimeout(() => {
        notificationEl.removeClass(this.CLASSES.show);
      }, 3000);
    }
  }
}
